// extracted by mini-css-extract-plugin
export default {"rightSide":"RHS_rightSide__q1mA+"};